import InvitationsList from './_InvitationsList';

export default InvitationsList;
